import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TaxiService {
  firstFormGroup = new BehaviorSubject(null);
  secondFormGroup = new BehaviorSubject(null);
  bookingConfirmation = new BehaviorSubject(null);
  tariff = new BehaviorSubject(null);

  constructor() { }
}
